import React from 'react';

import {Form, FormikProps} from 'formik';
import {CallMade} from '@material-ui/icons';
import {Box, Grid, Typography} from '@material-ui/core';

import {
    EfeErrorMsg,
    EfeFieldText,
    EfeBulletList,
    EfeButtonPrimary,
    EfePasswordField,
    EfeSupportMessage,
} from 'components';
import {useSpinner} from 'hooks';
import {data} from 'commons/defaults/recover-password';
import {Bullet, CreateAccountValues} from 'commons/models';

type Props = {
    title: string;
    isLoading: boolean;
};

function InnerFormCreate(props: Props & FormikProps<CreateAccountValues>) {
    const {title, isSubmitting, values, errors, handleBlur, handleChange, isLoading} = props;
    const bullets: Array<Bullet> = data;

    return (
        <Form noValidate>
            <Grid container direction='row' justifyContent='center'>
                {useSpinner(isLoading)}
                <Grid item xs={12}>
                    <Box flexGrow={0}>
                        <Typography variant='body1' color='textPrimary'>
                            {title}
                        </Typography>
                    </Box>
                    <EfeSupportMessage />
                    <Box flexGrow={0}>
                        <EfeBulletList bullets={bullets} />
                    </Box>

                    <Box m={2} marginTop={4}>
                        <EfeFieldText
                            fullWidth
                            id='rfc'
                            name='rfc'
                            label='RFC'
                            required={true}
                            placeholder='Ej. VECJ880326AH1'
                            value={values.rfc}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={!!errors.rfc}
                            helperText={errors.rfc}
                            inputProps={{
                                style: {
                                    textTransform: 'uppercase',
                                },
                            }}
                        />
                    </Box>

                    <Box m={2} marginTop={4}>
                        <EfeFieldText
                            fullWidth
                            id='email'
                            name='email'
                            required={true}
                            label='Correo electr&oacute;nico'
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={!!errors.email}
                            helperText={errors.email}
                        />
                    </Box>

                    <Box m={2} marginTop={4}>
                        <EfePasswordField
                            label={'Contrase\u00f1a *'}
                            handleBlur={handleBlur}
                            handleChange={handleChange}
                            value={values.password}
                            error={!!errors.password}
                        />
                        {errors.password && <EfeErrorMsg message={errors.password} />}
                    </Box>

                    <Box m={2} marginTop={4}>
                        <EfePasswordField
                            label={'Confirmar contrase\u00f1a *'}
                            name={'confirmPassword'}
                            handleBlur={handleBlur}
                            handleChange={handleChange}
                            value={values.confirmPassword}
                            error={!!errors.confirmPassword}
                        />
                        {errors.confirmPassword && <EfeErrorMsg message={errors.confirmPassword} />}
                    </Box>
                </Grid>
                <Grid item xs={4}>
                    <EfeButtonPrimary disabled={isSubmitting} endIcon={<CallMade />} type='submit'>
                        {'Aceptar'}
                    </EfeButtonPrimary>
                </Grid>
            </Grid>
        </Form>
    );
}

export default InnerFormCreate;
